var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vue, Component, Prop, Emit } from 'vue-property-decorator';
import { CarManageService } from "~/services/domain-service/car-manage.service";
import { Dependencies } from '~/core/decorator';
var OutgoingApplication = /** @class */ (function (_super) {
    __extends(OutgoingApplication, _super);
    function OutgoingApplication() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.dataForm = {
            userId: '',
            warehouseOutType: '',
            remark: '',
            planReturnTime: '',
            id: '',
            warehouseCarStatus: 'OUT_WAREHOUSE_WAIT_APPROVED',
        };
        _this.loading = false;
        _this.userList = [];
        _this.rules = {
            userId: { required: true, message: '请选择库管' },
            warehouseOutType: { required: true, message: '请选择出库类型' },
            planReturnTime: { required: true, message: '请选择预计归还时间' }
        };
        _this.pickerOptions = {
            disabledDate: function (time) {
                return time.getTime() < Date.now() - 3600 * 1000 * 24;
            },
        };
        return _this;
    }
    OutgoingApplication.prototype.emitClose = function () {
        this.reset();
    };
    OutgoingApplication.prototype.commit = function () {
        var _this = this;
        this.dataForm.id = this.rowData.id;
        this.dataForm.garageInfoId = this.rowData.garageInfoId;
        this.dataForm.planReturnTime = this.dataForm.warehouseOutType !== 'PERMANENT_OUT' ? this.$filter.dateTimeFormat(this.dataForm.planReturnTime) : '';
        var from = this.$refs['dataForm'];
        from.validate(function (valid) {
            if (!valid)
                return;
            _this.loading = true;
            _this.carManageService.updateWarehouseCar(_this.dataForm).subscribe(function (data) {
                _this.closeLoading();
                _this.$message.success('操作成功！');
                _this.emitClose();
            }, _this.closeLoading);
        });
    };
    OutgoingApplication.prototype.getUserList = function () {
        var _this = this;
        this.dataForm.userId = this.rowData.userId;
        if (!this.rowData.garageInfoId) {
            this.userList = [];
        }
        else {
            this.carManageService.getGarageUsersById(this.rowData.garageInfoId).subscribe(function (data) {
                _this.userList = data;
            });
        }
    };
    OutgoingApplication.prototype.closeLoading = function () {
        this.loading = false;
    };
    OutgoingApplication.prototype.reset = function () {
        var from = this.$refs['dataForm'];
        from.resetFields();
    };
    __decorate([
        Dependencies(CarManageService)
    ], OutgoingApplication.prototype, "carManageService", void 0);
    __decorate([
        Prop()
    ], OutgoingApplication.prototype, "rowData", void 0);
    __decorate([
        Emit('close')
    ], OutgoingApplication.prototype, "emitClose", null);
    OutgoingApplication = __decorate([
        Component({
            components: {}
        })
    ], OutgoingApplication);
    return OutgoingApplication;
}(Vue));
export default OutgoingApplication;
